
const url = "/api/v1/bookings/bookings";
import { getToken } from "./user-service";
import axios from "axios";

export const getFlights = async (params) => {
  const token = await getToken();
  const url =
    "/api/v1/bookings/bookingAnalytics/" + params.iata + "/flights" +
    "?startDate=" +
    params.date +
    "&endDate=" +
    params.date +
    "&type=" +
    params.type +
    '&noShows=' + params.noShows;

  // console.log('getting flights in service...', params)

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      // console.log("flights + " + params.type + " response: ", json.data);
      resolve(json.data);

    } catch (e) {
      console.log(e);
      reject(new Error("error getting bookings"));
    }
  });
};

export const getFlightsForecast = async (params) => {
  const token = await getToken();
  const url =
    "/api/v1/bookings/bookingAnalytics/" + params.iata + "/flightsForecast" +
    "?startDate=" +
    params.date +
    "&endDate=" +
    params.date +
    "&type=" +
    params.type +
    '&noShows=' +
    params.noShows;

  //console.log('getting flight in service...', url)

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      // console.log("flight forecast " + params.type + " response: ", json.data);
      resolve(json.data);

    } catch (e) {
      console.log(e);
      reject(new Error("error getting bookings"));
    }
  });
}

export const getFlightRouteForecast = async (params) => {
  // console.log('PARAMS', params)
  const token = await getToken();
  const url =
    "/api/v1/bookings/bookingAnalytics/" + params.iata + "/flightRouteForecast" +
    "?startDate=" +
    params.startDate +
    "&endDate=" +
    params.endDate +
    "&flightNumber=" +
    params.flightNumber +
    "&type=" +
    params.type +
    "&noShows=" +
    params.noShows;

  // console.log('getting flight route in service...', url)

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      // console.log("getFlightRouteForecast response: ", json.data);
      resolve(json.data);

    } catch (e) {
      console.log(e);
      reject(new Error("Missing flight route forecast..."));
    }
  });

};

export const getFlightInformation = async (params) => {

  // construct url for flight schedule
  let url = "/api/v1/flights/schedules?carrierCode=" + params.carrierCode + "&departureDate=" + params.departureDate + "&flightNumber=" + params.flightNumber;

  // console.log('getting flight info in service...', url);

  // get token
  const token = await getToken();

  return new Promise(async (resolve, reject) => {

    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      resolve(json.data);

    } catch (e) {
      reject(new Error("Issue finding flight information..."));
    }
  });
}

export const refreshFlightRoute = async (params) => {

  const token = await getToken();
  const url =
    "/api/v1/bookings/bookings/getFlightSchedule?flightNumber=" +
    params.flightNumber +
    "&carrierCode=" + params.carrierCode + "&origin=" + params.origin + "&destination=" + params.destination + "&departureDate=" + params.departureDate

  // console.log('getting flights route service...', url)

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      // console.log("response from route refresh", json.data);
      resolve(json.data);

    } catch (e) {
      console.log(e);
      reject(new Error("error getting bookings"));
    }
  });

}

export const getFlightAverage = async (params) => {
  // console.log('getting flight average in service...')
  const token = await getToken();

  // for later if we want to calculate averages over a range of dates
  let startDate = params.departureDate;
  let endDate = params.departureDate;

  const url =
    "/api/v1/bookings/bookingAnalytics/getFlightAverage" +
    "?startDate=" +
    startDate +
    "&endDate=" +
    endDate +
    "&flightNumber=" +
    params.flightNumber +
    "&origin=" +
    params.origin +
    "&destination=" +
    params.destination +
    "&departureDate=" +
    params.departureDate;

  console.log('getting flight averages in service...', url)

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.get(url, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        console.log('error getting flight averages')
        throw new Error("Bad booking details");
      }

      console.log("flight averages response: ", json.data);
      resolve(json.data);

    } catch (e) {
      console.log(e);
      reject(new Error("error getting bookings"));
    }
  });
}

export const createFlightSchedule = async (params) => {

  const token = await getToken();

  let url = "/api/v1/bookings/bookings/addFlightToSchedule?carrierCode=" +
    params.carrierCode +
    "&flightNumber=" +
    params.flightNumber +
    "&departureDate=" +
    params.departureDate +
    "&average=" +
    params.average;

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.patch(url, params, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      // console.log("flight updateFlightForecastRecord: ", json.data);
      resolve(json.data);

    } catch (e) {
      console.log(e);
      reject(new Error("error getting bookings"));
    }
  });
}

export const updateFlightForecastRecord = async (params) => {
  console.log('updateFlightForecastRecord', params);
  const token = await getToken();

  const url =
    "/api/v1/flights/schedules/forecastMethod?origin=" +
    params.origin +
    "&destination=" +
    params.destination +
    "&flightNumber=" +
    params.flightNumber +
    "&forecastMethod=" +
    params.forecastMethod +
    "&departureDate=" +
    params.departureDate +
    "&passengerVariance=" +
    params.passengerVariance +
    "&passengerNoShowVariance=" +
    params.passengerNoShowVariance

  // console.log('updating flight forecast record in service...', url)

  return new Promise(async (resolve, reject) => {
    try {
      const json = await axios.patch(url, params, {
        headers: { "Firebase-UID": token },
      });

      if (json.status >= 400 && json.status < 600) {
        throw new Error("Bad booking details");
      }

      // console.log("flight updateFlightForecastRecord: ", json.data);
      resolve(json.data);

    } catch (e) {
      console.log(e);
      reject(new Error("error getting bookings"));
    }
  });
}

export const patchFlight = async (params) => {
  const url = `/api/v1/flights/schedules/airportScheduleDocuments/${params.id}`;

  const token = await getToken();

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(params.body),
        headers: {
          "Firebase-UID": token,
          accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad flight details");
      }
      resolve(json);
    } catch (e) {
      console.log(e, "Error...123")
      reject(new Error("Error updating flight schedule..."));
    }
  });
};


export const getFlightById = async (flightId) => {
  const url = `/api/v1/flights/schedules/getFlightById/${flightId}`;
  const token = await getToken();
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        method: "GET",
        headers: { "Firebase-UID": token },
      });
      const json = await response.data;
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad flight details");
      }
      resolve(json);
    }
    catch (e) {
      console.log(e);
      reject(new Error("Error getting flight by id..."));
    }
  });
}

/**
 * Fetches third state airports from db
 * @returns [] iata codes
 */
export const getThirdStateAirports = async (iata) => {
  const url = `/api/v1/flights/timeline-flights/getThirdStateAirports`;
  const token = await getToken();
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, {
        method: "GET",
        headers: { "Firebase-UID": token },
        params: { iata },
      });
      const json = await response.data;
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad request");
      }
      console.log('third state list from backend ', json)
      resolve(json);
    }
    catch (e) {
      console.log(e);
      reject(new Error("Error getting flight by id..."));
    }
  });

}